import { useCallback, useState, useEffect } from 'react';
import useResizeObserver from '@segment/utils/useResizeObserver';

var useTableBasic = function useTableBasic(_ref) {
  var _tableRef$current;

  var table = _ref.table;

  var _useState = useState(false),
      stickyHeader = _useState[0],
      setStickyHeader = _useState[1];

  var _useState2 = useState(false),
      stickySidebar = _useState2[0],
      setStickySidebar = _useState2[1];

  var _useState3 = useState(null),
      tableRef = _useState3[0],
      setTableRef = _useState3[1];

  var checkIfHeaderIsSticky = useCallback(function () {
    var _table$current, _table$current2, _table$current2$paren, _table$current2$paren2;

    var tableHeight = Number(table === null || table === void 0 ? void 0 : (_table$current = table.current) === null || _table$current === void 0 ? void 0 : _table$current.getBoundingClientRect().height);
    var wrapperHeight = Number((_table$current2 = table.current) === null || _table$current2 === void 0 ? void 0 : (_table$current2$paren = _table$current2.parentElement) === null || _table$current2$paren === void 0 ? void 0 : (_table$current2$paren2 = _table$current2$paren.parentElement) === null || _table$current2$paren2 === void 0 ? void 0 : _table$current2$paren2.getBoundingClientRect().height);
    setStickyHeader(tableHeight > wrapperHeight);
  }, [table]);
  var checkIfSidebarIsSticky = useCallback(function () {
    var _table$current3, _table$current4, _table$current4$paren;

    var tableWidth = Number(table === null || table === void 0 ? void 0 : (_table$current3 = table.current) === null || _table$current3 === void 0 ? void 0 : _table$current3.getBoundingClientRect().width);
    var wrapperWidth = Number((_table$current4 = table.current) === null || _table$current4 === void 0 ? void 0 : (_table$current4$paren = _table$current4.parentElement) === null || _table$current4$paren === void 0 ? void 0 : _table$current4$paren.getBoundingClientRect().width);

    if (tableWidth > wrapperWidth) {
      setStickySidebar(true);
    } else {
      setStickySidebar(false);
    }
  }, [table]);
  useEffect(function () {
    if (table) {
      setTableRef(table);
      checkIfHeaderIsSticky();
      checkIfSidebarIsSticky();
    }
  }, [checkIfHeaderIsSticky, checkIfSidebarIsSticky, table]);
  useResizeObserver({
    current: tableRef === null || tableRef === void 0 ? void 0 : (_tableRef$current = tableRef.current) === null || _tableRef$current === void 0 ? void 0 : _tableRef$current.parentElement
  }, function () {
    checkIfHeaderIsSticky();
    checkIfSidebarIsSticky();
  });
  return {
    stickyHeader: stickyHeader,
    stickySidebar: stickySidebar
  };
};

export default useTableBasic;